import { render, staticRenderFns } from "./PeriodPlanGroup.vue?vue&type=template&id=0b947eee&"
import script from "./PeriodPlanGroup.vue?vue&type=script&lang=js&"
export * from "./PeriodPlanGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports